import { Dialog, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import * as React from "react";
import MessageBody from "../../shared/timeclock/components/MessageBody";
import { View, Session } from "../../shared/timeclock/reducers/session";

export const MessageOverlay = ({ session, dismiss }: { session: Session; dismiss: () => void }): JSX.Element => {
    const isIdentifying = (session.deviceResults && session.deviceResults.length > 0 && session.view !== View.Enrollment) || session.apiLoading;
    const message = session.messages[0];

    return (
        <Dialog
            scroll={"paper"}
            open={message || isIdentifying ? true : false}
            fullWidth={true}
            maxWidth={"md"}
        >
            {message && (message.userMessage || message.userMessageHeader) ? <DialogTitle>{message.userMessageHeader}</DialogTitle> : null}            
            <DialogContent>
                <MessageBody message={message} isIdentifying={isIdentifying} />
            </DialogContent>
            <DialogActions>
                {message && !message.device && !message.noButton ? <Button onClick={dismiss}>OK</Button> : null}
            </DialogActions>
        </Dialog>
    );
};
